import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Play = forwardRef<SVGSVGElement, Partial<IconProps>>(function Play({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 32 32" title="Play Button" description="Play video" ref={ref} {...props}>
      <path {...stylex.props([iconsStyles.neutralElement, styles])} d="M27.2 14.7c1.2.7 1.2 2.5 0 3.2L4.8 30.7c-1.3.7-2.8-.1-2.8-1.6V3.5c0-1.4 1.5-2.3 2.8-1.6l22.4 12.8Z" />
    </Icon>;
});